function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M305.178,15.32C277.876,5.439,241.761,0,203.522,0S129.14,5.439,101.837,15.32C62.754,29.464,54.503,47.574,54.503,60.275 v286.45c0,12.707,8.24,30.821,47.32,44.962c27.3,9.876,63.412,15.316,101.661,15.316c22.453,0.077,44.864-1.935,66.945-6.008 c52.129-10,82.074-29.783,82.074-54.27V60.275C352.503,47.574,344.261,29.464,305.178,15.32z M108.671,34.125 C133.847,25.015,167.526,20,203.503,20c35.977,0,69.656,5.018,94.832,14.129c25.137,9.1,34.093,19.473,34.093,26.149 c0,6.676-8.956,17.048-34.093,26.145v-0.001c-25.176,9.112-58.854,14.129-94.832,14.129c-35.978,0-69.656-5.017-94.832-14.129 c-25.137-9.1-34.093-19.472-34.093-26.148S83.534,43.223,108.671,34.125z M332.503,346.725c0,5.414-5.7,11.856-15.581,17.675 c-12.04,7.093-29.436,12.955-50.272,16.953c-20.825,3.837-41.962,5.729-63.138,5.65c-35.987,0-69.71-5.016-94.879-14.123 c-25.13-9.094-34.13-19.474-34.13-26.155v-64.408c8.524,5.579,17.699,10.094,27.32,13.446 c27.3,9.876,63.412,15.316,101.661,15.316c38.249,0,74.394-5.44,101.69-15.316c9.623-3.352,18.801-7.867,27.329-13.446V346.725z  M332.503,250.8c0,6.681-8.993,17.061-34.125,26.155c-25.169,9.107-58.869,14.123-94.856,14.123s-69.715-5.016-94.884-14.123 c-25.135-9.093-34.135-19.473-34.135-26.155v-63.746c8.524,5.579,17.699,10.094,27.32,13.446 c27.3,9.876,63.412,15.315,101.661,15.315c38.249,0,74.394-5.439,101.69-15.315c9.623-3.352,18.801-7.867,27.329-13.446V250.8z  M332.503,155.538c0,6.681-8.993,17.062-34.125,26.155v-0.001c-25.169,9.107-58.869,14.122-94.856,14.122 s-69.719-5.014-94.884-14.122c-25.135-9.092-34.135-19.473-34.135-26.154V91.782c8.526,5.579,17.702,10.095,27.324,13.447 c27.3,9.881,63.418,15.323,101.657,15.323c38.239,0,74.382-5.442,101.685-15.323c9.625-3.352,18.804-7.868,27.334-13.447V155.538z "
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M226.503,146.5h-46c-5.523,0-10,4.477-10,10s4.477,10,10,10h46c5.523,0,10-4.477,10-10S232.025,146.5,226.503,146.5z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M226.503,240.5h-46c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10h46c5.523,0,10-4.477,10-10 C236.503,244.977,232.025,240.5,226.503,240.5z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M226.503,337.5h-46c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10h46c5.523,0,10-4.477,10-10 C236.503,341.977,232.025,337.5,226.503,337.5z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

function SvgServerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.005 407.005",
    style: {
      enableBackground: "new 0 0 407.005 407.005"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerIcon);
export default __webpack_public_path__ + "static/media/server-icon.97273827.svg";
export { ForwardRef as ReactComponent };